<p-card *ngIf="venueSvc.ooVenue">
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="venueGroups"
		[paginator]="venueGroups && venueGroups.length > 10"
		[rows]="10"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
		[globalFilterFields]="['name']"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex p-grid">
				<div class="p-col-12 p-md-3">
					<h2>Venue Groups</h2>
				</div>
				<div class="p-col-12 p-md-3"></div>
				<div class="p-col-12 p-md-3">
					<span class="p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
							placeholder="Global Search"
						/>
					</span>
				</div>
				<div class="p-col-12 p-md-3 d-flex justify-content-end" style="text-align: right">
					<p-button pRipple styleClass="p-button-raised  m-2" (click)="venueGroupAdd()">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header" #header>
			<tr>
				<th>Name</th>
				<th>Dealer</th>
				<th>Venue Count</th>
				<th></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" #body let-rec let-idx="index">
			<tr>
				<td>{{ rec.name }}</td>
				<td>{{ rec.Dealer?.name }}</td>
				<td>
					<span *ngIf="rec.VenueGroupVenue">
						{{ rec.VenueGroupVenue.length }}
					</span>
				</td>
				<td class="d-flex justify-content-end" style="text-align: right">
					<p-button pRipple styleClass="p-button p-button-raised p-button-secondary m-2" (click)="venueGroupSelected = rec; selectVenueGroup(rec)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'pencil']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
					<p-button pRipple styleClass="p-button p-button-raised p-button-danger  m-2" (click)="venueGroupDelete(rec)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</p-card>

<focus-sidebar
	*ngIf="venueGroupSelected"
	[(visible)]="venueGroupSelected"
	header="Edit User"
	[showCloseIcon]="true"
	size="xxs"
	[dismissible]="true"
	(onClose)="venueGroupSelected = undefined"
	(onSave)="venueGroupPost()"
	[showFooter]="true"
>
	<p-card class="mb-2">
		<div class="p-grid">
			<div class="p-col">
				<input pInputText type="text" placeholder="Venue Group Name" name="name" [(ngModel)]="venueGroupSelected.name" class="w-100 m-2" />
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col">
				<span *ngIf="userService.user.role === 5 || userService.user.role === 6">
					<p-dropdown
						[options]="dealers"
						optionLabel="name"
						optionValue="key"
						name="dealerList"
						[filter]="true"
						filterBy="name"
						[(ngModel)]="venueGroupSelected.dealerKey"
						(onChange)="dealerVenuesGet(venueGroupSelected.dealerKey)"
						styleClass="m-2"
						[style]="{ width: '100%' }"
						appendTo="body"
					></p-dropdown>
				</span>
				<span *ngIf="userService.user.role < 5">
					{{ venueGroupSelected.Dealer.name }}
				</span>
			</div>
		</div>
	</p-card>
	<p-card class="mb-2">
		<p-listbox
			[options]="venueList"
			[(ngModel)]="venueGroupSelectedVenueKeys"
			optionLabel="name"
			optionValue="key"
			[filter]="true"
			[multiple]="true"
			[checkbox]="true"
		></p-listbox>
	</p-card>
</focus-sidebar>
